const signUpButtons = document.querySelectorAll("button.sign-up-button"),
  signUpModal = document.getElementById("sign-up-dialog"),
  closeDialogButton = signUpModal.querySelector('button[data-dismiss="modal"]');

// open the sign up modal when a user clicks a button in the nav
for (const signUpButton of signUpButtons) {
  signUpButton.addEventListener("click", function (evt) {
    signUpModal.showModal();
  });
}
// close the sign up dialog when the X button is hit
closeDialogButton.addEventListener("click", function (evt) {
  signUpModal.close();
});
